import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const getEmployees = createAsyncThunk(
  "employees/getEmployees",
  async ({ status }) => {
    try {
      const token = await getFirebaseAuthToken();
      let url = `${API_BASE}/dashboard/employer/employees`;
      if (status === "inactive") {
        url += `/inactive`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching ${status} employees`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const postEmployee = createAsyncThunk(
  "employees/postEmployee",
  async (employee) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(`${API_BASE}/dashboard/employer/employees`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify(employee),
    });
    const data = await response.json();
    return data;
  }
);

export const postEmployees = createAsyncThunk(
  "employees/postEmployee",
  async (employees) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/employer/employees/multiple`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({ employees }),
      }
    );
    const data = await response.json();
    return data;
  }
);

export const putEmployee = createAsyncThunk(
  "employees/putEmployee",
  async (employee) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/employer/employees/${employee.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(employee),
      }
    );
    const data = await response.json();
    return data;
  }
);

export const deleteEmployee = createAsyncThunk(
  "employees/deleteEmployee",
  async (id) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/employer/employees/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  }
);

export const postInviteCode = createAsyncThunk(
  "employees/getInviteCode",
  async (inviteCode) => {
    const token = await getFirebaseAuthToken();

    const response = await fetch(`${API_BASE}/dashboard/invite-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify(inviteCode),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Something went wrong");
    }

    console.log(response);
    return data;
  }
);

// export const deactivateEmployee = createAsyncThunk(
//   "employees/deactivateEmployee",
//   async (id) => {
//     const token = await getFirebaseAuthToken();
//     const response = await fetch(
//       `${API_BASE}/dashboard/employer/employees/${id}/deactivate`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `${token}`,
//         },
//         body: JSON.stringify({ id }),
//       }
//     );
//     const data = await response.json();
//     return data;
//   }
// );

// ACTIVATE / DEACTIVATE EMPLOYEE
export const deactivateEmployee = createAsyncThunk(
  "employees/deactivateEmployee",
  async ({ id, status }) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/employer/employees/${id}/${status}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({ id }),
      }
    );
    const data = await response.json();
    return data;
  }
);
